import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_soap_6: FaireProductEntity = {
  token: "nyc-soap-6",
  type: "product",
  name: "Eucalyptus Mint Soap Bar",
  brandName: "Herbal Wellness Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/43128be521c1b7639d3f9404deeb68c2460546c0bc51064bf9746d4f47abbcbe.webp",
  priceDollars: 14,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/43128be521c1b7639d3f9404deeb68c2460546c0bc51064bf9746d4f47abbcbe.webp",
  weight: 0.4,
  dimensions: {
    width: 3,
    height: 4,
    depth: 1.5,
  },
  description: "Tea tree oil soap from Tribeca",
  categoryTokens: ["cat_bath-all"],
  tags: ["nyc-local", "premium", "organic"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
